const topics = [
  { name: '悬疑烧脑', heat: '🔥 热播', color: 'bg-primary-100 text-primary-700 hover:bg-primary-200' },
  { name: '古装权谋', heat: '📈 上升', color: 'bg-accent-100 text-accent-700 hover:bg-accent-200' },
  { name: '甜宠爱情', heat: '💥 爆款', color: 'bg-pink-100 text-pink-600 hover:bg-pink-200' },
  { name: '动作大片', heat: '🔥 热播', color: 'bg-orange-100 text-orange-600 hover:bg-orange-200' },
  { name: '喜剧解压', heat: '👍 推荐', color: 'bg-green-100 text-green-600 hover:bg-green-200' },
  { name: '纪录片', heat: '📈 上升', color: 'bg-blue-100 text-blue-600 hover:bg-blue-200' },
  { name: '国漫崛起', heat: '💥 爆款', color: 'bg-purple-100 text-purple-600 hover:bg-purple-200' },
  { name: '综艺热综', heat: '🔥 热播', color: 'bg-amber-100 text-amber-600 hover:bg-amber-200' },
  { name: '港片经典', heat: '👍 推荐', color: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200' },
  { name: '日韩剧场', heat: '📈 上升', color: 'bg-rose-100 text-rose-600 hover:bg-rose-200' },
  { name: '科幻巨制', heat: '🔥 热播', color: 'bg-cyan-100 text-cyan-600 hover:bg-cyan-200' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          话题广场
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">热门影视话题标签，发现更多你感兴趣的内容</p>
        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic) => (
            <span
              key={topic.name}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 md:px-4 md:py-2 rounded-full text-xs md:text-sm font-label font-medium cursor-pointer transition-colors ${topic.color}`}
            >
              {topic.name}
              <span className="text-[10px] md:text-xs opacity-80">{topic.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}